import React from "react";
import { Box, Tab } from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";


const TabsComponent = ({handletabs,activeTab,tabStyle}) => {

    return (
        <Box
            sx={{ bgcolor: "background.paper", width: "100%" }}
            style={{ background: "rgb(38 80 119)", width: "100%" }}
        >
            <TabContext value={activeTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                        onChange={handletabs}
                        aria-label="lab API tabs example"
                        indicatorColor="secondary"
                    >
                        <Tab label="All" value="1" style={tabStyle} />
                        <Tab label="Pending" value="2" style={tabStyle} />
                        <Tab label="Resolved" value="3" style={tabStyle} />
                        <Tab label="Roadmap" value="4" style={tabStyle} />
                        <Tab label="In-Progress" value="5" style={tabStyle} />
                        <Tab label="Development" value="6" style={tabStyle} />
                        <Tab label="Administrator" value="7" style={tabStyle} />
                    </TabList>
                </Box>
            </TabContext>
        </Box>
    );
};
export default TabsComponent;
